export default {
  drivers: 'السائقين',
  driverName: 'اسم السائق',
  phoneNumber: 'رقم التليفون',
  tripsCount: 'عدد الرحلات',
  imports: 'الواردات',
  paymentWay: 'طريقة الحساب',
  lastTrip: 'اخر عملية نقل',
  control: 'التحكم',
  addDriver: 'اضافة سائق',
  vehicles: 'المركبات'
}
